import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=7c213787&scoped=true&lang=less"

import exportComponent from "E:\\Code\\TECS\\TECS-FE-ENDUSER-NEW\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c213787"]])

export default __exports__